import * as yup from 'yup';

const phoneRegex = /^(\+62|62|0)8[1-9][0-9]{6,10}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const identitySchema = yup.object({
  identity: yup
    .string()
    .required('Email atau nomor HP wajib diisi')
    .test('email-or-phone', 'Format email atau nomor HP tidak valid', function(value) {
      if (!value) return false;
      
      if (emailRegex.test(value)) {
        return true;
      }
      
      if (phoneRegex.test(value)) {
        return true;
      }
      
      return false;
    })
});

export type IdentityFormData = yup.InferType<typeof identitySchema>;